module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/capone360@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/capone360@2x.png
// module id = 1159
// module chunks = 0